import React, { useState } from "react";
import ChoiceButtons from './ChoiceButtons';
import Countdown from 'react-countdown';
import FlashCard from './Card';
import Status from './Status';
import { sendGuess } from './apiClient';

const GameController = props => {

  const [ question, setQuestion ] = useState(props.question);
  const [ timeout, setTimeout ] = useState(Date.now() + (props.timeLimit * 1000));

  const processGuess = (guess) => {
    let newCorrect = props.correct;
    let newIncorrect = props.incorrect;
    if (guess === question.correctAnswer) { newCorrect = parseInt(props.correct) + 1; } else { newIncorrect = parseInt(props.incorrect) + 1; }
    props.gamePropertySetters.correctSetter(newCorrect);
    props.gamePropertySetters.incorrectSetter(newIncorrect);
    props.gamePropertySetters.remainingSetter(props.game.questionCount - (newCorrect + newIncorrect));
    sendGuess({ gameId:props.game.id, sequenceNumber:question.sequenceNumber, guess:guess, processNextQuestion:processNextQuestion });
  };

  const processNextQuestion = (nextQuestion) => {
    if (nextQuestion.sequenceNumber === question.sequenceNumber) {
      props.gamePropertySetters.gameOverSetter(true);
      return;
    }
    setQuestion(nextQuestion);
    setTimeout(Date.now() + (props.timeLimit * 1000));
  };

  if (props.timeLimit > 0) {
    return (
      <div className="game-layout">
        <table border="0">
          <tbody>
            <tr>
              <td width="70%">
                <Status game={props.game} question={question} correct={props.correct} incorrect={props.incorrect} remaining={props.remaining} />
              </td>
              <td width="30%" align="right">
                <Countdown
                  className="countdown"
                  date={timeout}
                  key={timeout}
                  onComplete={() => processGuess('X')}
                /> 
              </td>
            </tr>
            <tr><td colSpan="2" align="center"> <FlashCard     game={props.game} question={question} /> </td></tr>
            <tr><td colSpan="2"> <ChoiceButtons game={props.game} question={question} guessCallback={processGuess} /> </td></tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="game-layout">
      <table border="0">
        <tbody>
          <tr>
            <td width="70%">
              <Status game={props.game} question={question} correct={props.correct} incorrect={props.incorrect} remaining={props.remaining} />
            </td>
          </tr>
          <tr><td> <FlashCard     game={props.game} question={question} /> </td></tr>
          <tr><td> <ChoiceButtons game={props.game} question={question} guessCallback={processGuess} /> </td></tr>
        </tbody>
      </table>
    </div>
  );
}

export default GameController;


